
Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.ResequenceHistoryGrid = function (routeId) {

    const idScreen = "routeMaps_" + routeId;
    const screenTab = "#" + idScreen;
    const container = screenTab + " #routeDetailPRO";
    const entity = `RouteDetails_${routeId}_ResequenceHistory`;

    this.addActionsToGrid = function () {

        var error                 = null,
            customizeColumns      = null,
            element               = null,
            saveGridLayout        = null,
            selectorToGridActions = screenTab + " #tabsRouteDetail .gridActions",
            entityToActionGrid    = "ProactiveRouteOpt";

        try {
            const afterSaveListCallback = () => {
                const resequenceHistory = Monet.Session.RouteDetail.screensList[routeId].resequenceHistory.data;
                App.Forms[entity].layout = {};

                delete App.Forms.RouteDetail.layout;

                const resequenceHistoryGridHandler = new Greenmile.RouteDetail.ResequenceHistoryGrid(routeId);
                resequenceHistoryGridHandler.createGrid(resequenceHistory);
            };

            customizeColumns = new Monet.Grid.ActionsModules.CustomizeColumns();
            saveGridLayout = new Monet.Grid.ActionsModules.SaveGridLayout();

            element = document.querySelector(selectorToGridActions);

            if (element) {
                element.innerHTML = '';
            }

            customizeColumns.setEntity(entityToActionGrid);
            customizeColumns.setScreenName(entity);
            customizeColumns.setSelector(selectorToGridActions);
            customizeColumns.setElement(element);
            customizeColumns.setCustomNamespace('RouteDetails_' + routeId + '_ResequenceHistory');

            customizeColumns.setCallBacks({
                afterSaveList: afterSaveListCallback
            });

            saveGridLayout.setEntity(entityToActionGrid);
            saveGridLayout.setScreenName(entity);
            saveGridLayout.setSelector(selectorToGridActions);
            saveGridLayout.setElement(element);

            saveGridLayout.setCallBacks({
                afterSaveList: afterSaveListCallback
            });

            customizeColumns.init();
            saveGridLayout.init();

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on showing resequence PRO grid on route detail.', e);
            error.console();

        }
    };

    this.addFilterBuilder = function () {

        let filterBuilder = App.Forms[entity].filterBuilder;
        const filterBuilterDiv = document.querySelector(`${screenTab} .resequenceHistory.gridActions.ui-widget-header`);

        if (!filterBuilterDiv) {

            filterBuilder = new Monet.UI.FilterBuilder();
            filterBuilder.setIdScreen(idScreen);
            filterBuilder.setSelector(`${screenTab} #routeDetailPRO`);
            filterBuilder.setEntity('ProactiveRouteOpt');
            filterBuilder.getFieldList();
            filterBuilder.setCustomNameSpace(entity);

            const selectorToGridActions = `${screenTab} #tabsRouteDetail .gridActions`;
            const gridActions = document.querySelector(selectorToGridActions);

            if (gridActions) {
              const div = document.createElement('div');
              div.className = 'resequenceHistory gridActions ui-widget-header';
              div.appendChild(filterBuilder.el);

              gridActions.parentNode.appendChild(div);
            }

            filterBuilder.render(undefined, true);
            App.Forms[entity].filterBuilder = filterBuilder;

        }

        filterBuilder.adjustHeaderSize();
    };

    this.populateGrid = function (resequenceHistoryData, columns) {
        Monet.Grid.addDataToGrid(entity, columns, resequenceHistoryData, false, { scrollRowToTop: false, blockFormatData: true });
    };

    this.createGrid = async function (resequenceHistoryData, { isToAddActions = true } = {}) {
        var columnProvider = new Greenmile.RouteDetail.ResequenceColumnsToGrid();
        var columns,
            dataView,
            grid,
            appForms,
            selectorToGridActions = screenTab + " #tabsRouteDetail .gridActions",
            entityToActionGrid    = "StopView";

        var options = {
            entity: entity,
            columnCheckBox: {
                show: false
            },
            selectorToGridActions: selectorToGridActions,
            entityToActionGrid: entityToActionGrid,
            gridContainner: container,
            columnEdit: {
                show: false
            },
            headerMenu: {
                headerMenuEventClass: Monet.Grid.ActionsModules.MenuShowTotals
            },
            multiColumnSort: true,
            rowHeight: 30,
            multiSelect: false,
            sortBy: 'client',
        };

        columnProvider.setEntity(entity);
        columns = await columnProvider.getColumns();
        dataView = new Monet.Grid.DataProvider(columns, null, entity);

        var columnFrozen = Monet.Grid.getIndexFrozenColumn(App.Forms[entity].layout.index);
        options.frozenColumn = columnFrozen + 1;

        if (!document.querySelector(container)) return;

        grid = new Monet.Grid.GenericGrid(container, dataView, columns, options);

        appForms = App.Forms[entity];
        appForms.routeId = routeId;
        appForms.table = grid;
        appForms.dataProvider = dataView;
        appForms.gridResequenceHistory = this;


        if (isToAddActions) {
            this.addActionsToGrid(columns);
        }

        this.addFilterBuilder();

        const collection = new App.Collections.BaseCollection();
        collection.add(resequenceHistoryData);
        this.populateGrid(collection, columns);

        if(!Monet.Session.RouteDetail.screensList[routeId].resequenceHistory) {
            Monet.Session.RouteDetail.screensList[routeId].resequenceHistory = {};
            Monet.Session.RouteDetail.screensList[routeId].resequenceHistory.data = resequenceHistoryData;
        }

        App.Views.RouteDetails.adjustProGridFooter();

    };

};
